module.exports = __webpack_public_path__ + "img/11.3fb9fcf7.jpg";